// See how the options work here: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
let options = {
    root: null,
    rootMargin: "0px",
    threshold: 0,
};

export const lazyLoad = (image: HTMLImageElement, src: string) => {
    const loaded = () => {
        image.classList.add("visible"); // manipulate the image node after load (trigger animations)
        image.removeEventListener("load", loaded); // clean up the event listener
    };
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                image.src = src; // replace placeholder src with the image src on observe
                if (image.complete) {
                    // check if instantly loaded
                    loaded();
                } else {
                    image.addEventListener("load", loaded); // if the image isn't loaded yet, add an event listener
                }
                observer.unobserve(image); // unobserve image after switching the SRC
            }
        });
    }, options);
    observer.observe(image); // intersection observer
};

export const lazy_load_with_fallback = (
    image: HTMLImageElement,
    { src, fallback }: { src: string; fallback: string }
) => {
    const loaded = () => {
        image.classList.add("visible"); // manipulate the image node after load (trigger animations)
        image.removeEventListener("load", loaded); // clean up the load event listener
        image.removeEventListener("error", error); // clean up the error event listener

        const width = image.naturalWidth;
        const height = image.naturalHeight;
        // check to see if there was a 404 error on image
        if (width === 120 && height === 90) {
            error(); // use the fallback url if the image is 120x90px
        }
    };
    const error = () => {
        image.src = fallback; // replace with fallback src on error
        image.removeEventListener("error", error); // remove the error event listener
        image.addEventListener("load", loaded); // add load event listener for the fallback image
    };
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                image.addEventListener("error", error); // add an error event listener
                image.src = src; // replace placeholder src with the image src on observe

                if (image.complete) {
                    // check if instantly loaded
                    loaded();
                } else {
                    image.addEventListener("load", loaded); // if the image isn't loaded yet, add a load event listener
                }
                observer.unobserve(image); // unobserve image after switching the SRC
            }
        });
    }, options);
    observer.observe(image); // intersection observer
};
